import { useState } from "react"
import { NavLink } from "react-router-dom"

import PaymentSolutions from "../../assets/services-page/paymentSolutions/payment-solutions.png"
import BayadPayLogo from "../../assets/services-page/paymentSolutions/bayadpay-logo.png"
import Payment from "../../assets/services-page/paymentSolutions/payment.png"
import QrCode from "../../assets/services-page/paymentSolutions/1.png"
import DigitalWallet from "../../assets/services-page/paymentSolutions/2.png"
import RealTime from "../../assets/services-page/paymentSolutions/3.png"


const AFCS = () => {

    const [cardActive, setCardActive] = useState(true)

    const handleCardToggle = () => {
        setCardActive(prev => !prev)
    }

    return (
        <>
            <div className="afcs">
                <div className="page-header">
                    <div className="container d-flex justify-content-center align-items-center flex-column">
                        <img src={PaymentSolutions} className="page-banner" alt="" style={{backgroundPosition: "right"}} />
                        <h1 className='fw-bold text-center'>Payment Solutions</h1>
                    </div>
                </div>

                <div className="container my-5 d-flex align-items-center gap-5 flex-column flex-lg-row">
                    <div className="d-flex justify-content-center align-items-center flex-column">
                        <h3 className="text-center fw-semibold mb-5">
                            Bayad Pay – Easy and Convenient Payment for Grocery Shopping
                        </h3>
                        <p className="text-justify m-0">
                            Bayad Pay offers a fast, secure, and hassle-free way to pay for your groceries. 
                            Whether you’re shopping at a supermarket or a local store, Bayad Pay allows you to 
                            settle your bill instantly using your mobile phone. Just scan, tap, or confirm—no need 
                            to carry cash or wait in long lines. With real-time payment confirmation and a user-friendly 
                            interface, Bayad Pay makes your grocery experience smarter and more convenient.
                        </p>
                    </div>

                    <div className="d-flex flex-md-row flex-column gap-3">
                        <img src={BayadPayLogo} style={{width: "400px"}} alt="Bayad Pay Logo" />
                    </div>
                </div>

                <div className="container mb-5">
                    <div className="payment-cards d-flex justify-content-center align-items-center gap-3 flex-wrap">
                        <div className="p-card p-3 rounded d-flex justify-content-center align-items-center flex-column">
                            <img style={{width: "100px"}}src={QrCode} alt="" />
                            <h5>Unique QR Code</h5>
                            <p className="m-0 text-center">
                                Each BayadPay user is assigned a personalized QR code linked to their digital wallet.
                            </p>
                        </div>
                        <div className="p-card p-3 rounded d-flex justify-content-center align-items-center flex-column">
                            <img style={{width: "100px"}}src={DigitalWallet} alt="" />
                            <h5>Digital Wallet Integration</h5>
                            <p className="m-0 text-center">
                                The QR code is connected directly to the user’s BayadPay account, allowing fast and secure payments.
                            </p>
                        </div>
                        <div className="p-card p-3 rounded d-flex justify-content-center align-items-center flex-column">
                            <img style={{width: "100px"}}src={RealTime} alt="" />
                            <h5>Real-Time Settlement</h5>
                            <p className="m-0 text-center">
                                Transactions are processed instantly, ensuring immediate confirmation for both user and merchant.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="container mb-5 d-flex justify-content-center align-items-center flex-column">
                    <img src={Payment} className="rounded w-100" alt="" style={{maxWidth:"700px"}}/>
                </div>

                <div className="text-center bg-dark text-light p-4">
                    <div className="container">
                            <h4 className="fw-bold">The Smarter Way to Accept Card Payments.</h4>
                            <NavLink to='/contactus' className="btn home-cta fw-semibold">Inquire now</NavLink>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AFCS;